import { SvgProps } from "utils/types/app";

function CusorAiIcon(props: SvgProps) {
  return (
    <svg
      width={218}
      height={223}
      viewBox="0 0 218 223"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M203.512 62.648c11.43 18.35 15.47 38.49 14.23 59.79-1.45 24.64-10.67 46-27.47 64.17-9.75 10.54-20.67 19.47-33.62 25.82-16.8 8.25-34.61 11.25-53.19 10.28a108.283 108.283 0 01-91.46-58.5 101.42 101.42 0 01-12-47.42c-.15-26.35 8.79-49.48 25.7-69.51 13.14-15.58 29.33-26.72 49-32.56 2.19-.64 4.56-.91 5.07-3.66.185-1.278.226-2.573.12-3.86 0-1.44-.31-2.88-.2-4.29a2.75 2.75 0 013.2-2.87c1.863.105 3.7.49 5.45 1.14a4263.8 4263.8 0 0141.77 16.8c5.66 2.31 6 4.82 1.83 9.23-5 5.29-9.77 10.83-14.73 16.19l-6.89 7.31c-3.7 3.93-7.42 7.83-11.15 11.74a3.84 3.84 0 01-6.67-1.45c-.26-.71-.4-1.45-.6-2.17-1-3.43-2.8-4.25-6.34-3.41-.866.202-1.717.46-2.55.77a25.082 25.082 0 00-4.33 2.09 65.84 65.84 0 0016.16 122.46 47.276 47.276 0 0020.57 1.33 65.814 65.814 0 0056.225-44.156 65.81 65.81 0 00-17.225-69.384"
        fill="currentColor"
      />
      <path
        d="M108.993 167.217c26.758 0 48.45-21.691 48.45-48.45 0-26.758-21.692-48.45-48.45-48.45-26.758 0-48.45 21.692-48.45 48.45 0 26.759 21.692 48.45 48.45 48.45z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CusorAiIcon;
